import React, { memo, useRef, useState } from "react";
import { AnimatePresence, motion, easeInOut } from "framer-motion";
import { MyButton } from "components/button";
import { useRootContext } from "context/app-context";
import { useOutsideClickHook } from "hooks/useOutsideClick";
import { getTruncatedAddress, walletIcon } from "utils/helper";
import { useWalletConnect } from "context/wallet-connection-context";

const ConnectWallet = () => {
  const disconnectRef = useRef(null);
  const [openDisconnect, setOpenDisconnect] = useState(false);
  useOutsideClickHook(disconnectRef, () => setOpenDisconnect(false));
  const { isSignWallet,handleToggleWalletSidebar } = useRootContext();
  const { address, connector,handleDisconnectWallet } = useWalletConnect();
  return (
    <>
      {/* BEFORE LOGIN BUTTON */}
      {!isSignWallet && (
        <div className="deskOnly">
          <MyButton
            text="Connect Wallet"
            className="custom-btn md dark rounded"
            handleClick={() => handleToggleWalletSidebar()}
          />
        </div>
      )}

      {!isSignWallet && (
        <div className="mobOnly">
          <MyButton
            className="custom-btn dark md icon rounded"
            iconButton
            iconButtonImage={process.env.REACT_APP_S3_IMAGE_PATH + "wallet.svg"}
            handleClick={() => handleToggleWalletSidebar()}
          />
        </div>
      )}

      {/* AFTER LOGIN BUTTON */}
      {isSignWallet && (
        <div ref={disconnectRef} className="afterLogin customDropdown">
          <div className="deskOnly">
            <MyButton
              text={getTruncatedAddress(address)}
              className="custom-btn md dark icon-btn rounded"
              handleClick={() => {
                setOpenDisconnect(!openDisconnect);
              }}
              iconButtonImage={
              walletIcon[connector?.id]
              }
              arrowIcon={process.env.REACT_APP_S3_IMAGE_PATH + "arrowDark.svg"}
            />
          </div>
          <div className="mobOnly">
            <MyButton
              className="custom-btn md dark icon"
              handleClick={() => {
                setOpenDisconnect(!openDisconnect);
              }}
              iconButtonImage={
                walletIcon[connector?.id]
              }
            />
          </div>

          <AnimatePresence>
            {openDisconnect && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.35, ease: easeInOut }}
                className="disconnectDropdown innerDropdown"
              >
                <button className="link-btn" onClick={()=>{
                  handleDisconnectWallet()
                  // setTimeout(()=>{
                  //   pageRefresh()
                  // },1000)
                  }}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 3.69776V12.196C16 13.0863 15.4286 13.9766 14.5306 14.3003L10.449 15.8381C10.2041 15.9191 9.95918 16 9.63265 16C9.22449 16 8.73469 15.8381 8.32653 15.5953C8.16327 15.4334 7.91837 15.2716 7.83674 15.1097H4.73469C3.5102 15.1097 2.44898 14.1385 2.44898 12.8435V12.0341C2.44898 11.7104 2.69388 11.3867 3.10204 11.3867C3.5102 11.3867 3.7551 11.6295 3.7551 12.0341V12.8435C3.7551 13.4101 4.2449 13.8147 4.73469 13.8147H7.42857V2.15998H4.73469C4.16327 2.15998 3.7551 2.56465 3.7551 3.1312V3.94056C3.7551 4.26431 3.5102 4.58805 3.10204 4.58805C2.69388 4.58805 2.44898 4.26431 2.44898 3.94056V3.1312C2.44898 1.91717 3.42857 0.865002 4.73469 0.865002H7.83674C8 0.70313 8.16327 0.541258 8.32653 0.379387C8.97959 -0.0252925 9.71429 -0.106228 10.449 0.136579L14.5306 1.67436C15.3469 1.91717 16 2.80746 16 3.69776Z"
                      fill="white"
                    />
                    <path
                      d="M2.28571 10.2536C2.12245 10.2536 1.95918 10.1726 1.87755 10.0917L0.244898 8.47297C0.163265 8.39203 0.163265 8.3111 0.0816326 8.3111C0.0816326 8.23016 0 8.14923 0 8.06829C0 7.98735 -7.90674e-08 7.90642 0.0816326 7.82548C0.0816326 7.74455 0.163265 7.66361 0.244898 7.66361L1.87755 6.04489C2.12245 5.80209 2.53061 5.80209 2.77551 6.04489C3.02041 6.2877 3.02041 6.69238 2.77551 6.93519L2.20408 7.50174H5.55102C5.87755 7.50174 6.20408 7.74455 6.20408 8.14923C6.20408 8.5539 5.87755 8.63484 5.55102 8.63484H2.12245L2.69388 9.20139C2.93878 9.4442 2.93878 9.84888 2.69388 10.0917C2.61225 10.1726 2.44898 10.2536 2.28571 10.2536Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_849_241"
                        x1="0"
                        y1="0"
                        x2="17.3277"
                        y2="13.4591"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0.268769" stopColor="#50FDDB" />
                        <stop offset="0.691445" stopColor="#03D9AF" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_849_241"
                        x1="0"
                        y1="0"
                        x2="17.3277"
                        y2="13.4591"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0.268769" stopColor="#50FDDB" />
                        <stop offset="0.691445" stopColor="#03D9AF" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <span className="link">Disconnect Wallet</span>
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      )}
    </>
  );
};

export default memo(ConnectWallet);
